module.exports = __webpack_public_path__ + "resources/img/docker-advanced-screenshot.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/docker-advanced-screenshot.png
// module id = 1280
// module chunks = 0